<template>
  <div v-if="Object.keys(allData).length" class="report-14">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->
    <div v-for="(item, i) in allData.items" :key="i" class="report-5" dir="rtl">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card style="padding: 0px 25px; padding-bottom: 20px">
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">
                  المصرف : {{ allData.items[i].bankBranch }}
                </h4>
              </div>
            </md-card-header>

            <div style="direction: initial" class="md-layout mt-25">
              <div class="md-layout-item md-size-100">
                <h4 class="text-center">
                  <span style="font-weight: bold">{{
                    allData.items[i].fullName
                  }}</span>
                </h4>
                <h4 class="text-center">{{ allData.items[i].shortName }}</h4>
                <h3 class="text-center">حافظة ارفاق صك بمرتبات موظفين</h3>
              </div>

              <div class="md-layout-item md-size-100">
                <h4 class="text-left" style="margin-left: 84px">
                  التاريخ : {{ date }}
                </h4>
                <h4 class="text-left" style="margin-left: 34px">
                  المصرف : {{ allData.items[i].bankBranch }}
                </h4>
              </div>
            </div>

            <!-- <img v-if="i % 24 == 0" class="report-logo" src="/img/ns.png" alt="" /> -->
            <!-- <header v-if="i % 24 == 0">
        <div class="titlee">
          <h2 class="text-center">
            {{ name }}
          </h2>
          <h3 class="text-center">
            {{ desc }}
          </h3>
        </div>
        <h3 class="main-title">( حافظة ارفاق صك بمرتبات موظفين )</h3>
        

        <h4 class="dates">
          تاريخ الطباعة :
          <span class="display: inline-block">{{ date }}</span>
        </h4>

        
      </header> -->

            <div class="second">
              <p>نوع المعاملة</p>
              <p>مرتبات الموظفين</p>
            </div>

            <div class="third">
              <span style="display: inline-block"
                >نرفقك لكم بهذا الصك رقم :
                ...................................</span
              >
              <span style="display: inline-block; margin-right: 15px"
                >بتاريخ: ..................................</span
              >
              <span style="display: inline-block; margin-right: 10px">20ف</span>
              <span style="display: inline-block; margin-right: 10px"
                >بمبلغ:
              </span>
              <span style="display: inline-block; margin-right: 10px">
                {{ formatValues(allData.items[i].totalNetSalaries) }}
              </span>
            </div>
            <div class="forth">
              <div class="one">
                <p>
                  وهو عبارة عن مرتبات الموظفين. يرجى قيد القيمة لحساباتهم
                  المفتوحة لديكم وفقا للبيانات المدرجة فيما يلى
                </p>
                <div class="form">
                  <p>رقم الاستمارة : .......................................</p>
                  <p>شهر : {{ month }}</p>
                </div>
              </div>
              <div class="two">
                <p>إجمالى الصرف</p>
                <p>{{ formatValues(allData.items[i].totalNetSalaries) }}</p>
              </div>
            </div>

            <md-table
              style="margin-top: 50px"
              :value="allData.items[i].items"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table custome-paginated-table table-striped table-hover mt-25 font-size-style"
            >
              <md-table-row
                class="font-size-style-row"
                slot="md-table-row"
                slot-scope="{ item }"
              >
                <md-table-cell md-label="الرقم المالي">
                  <p>
                    {{ item.financialNumber }}
                  </p>
                </md-table-cell>

                <md-table-cell md-label="الرقم الوطني">
                  <p>
                    {{ item.nationalNumber }}
                  </p>
                </md-table-cell>

                <md-table-cell md-label="اسم الموظف">
                  <p>
                    {{ item.employeeName }}
                  </p>
                </md-table-cell>

                <md-table-cell md-label="رقم الحساب">
                  <p>
                    {{ item.accountNumber }}
                  </p>
                </md-table-cell>

                <md-table-cell md-label="صافي المرتب">
                  <p>
                    {{ formatValues(item.netSalary) }}
                  </p>
                </md-table-cell>
                <md-table-cell md-label="صافي المرتب"> </md-table-cell>
              </md-table-row>
            </md-table>

            <section style="margin-top: 30px" class="report-14-footer">
              <p>عدد المرتبات بالحافظة = {{ allData.items[i].items.length }}</p>
              <p>
                مجموع الحافظة =
                {{ formatValues(allData.items[i].totalNetSalaries) }}
                دينار ليبى
              </p>
              <!-- <p>دينار ليبى</p> -->
            </section>

            <section class="last">
              <p>رقم الصك : ...................</p>
              <p>
                مجموع الحافظة =
                {{ formatValues(allData.items[i].totalNetSalaries) }}
              </p>
              <p>دينار ليبى</p>
            </section>
          </md-card>
        </div>
      </div>
    </div>

    <section style="margin-right: 18px; margin-left: 18px" class="manger">
      <p>رئيس قسم الحسابات</p>
      <p>المراجعة الداخلية</p>
      <p>المراقب المالى</p>
    </section>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["month", "date", "name", "desc", "allData"],
  mounted() {
    // this.allData.items.push(...this.items);
  },
  data() {
    return {
      items: [
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
          m: env.mTop(),
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119710039889",
          employeeName: "محمد سالم بلقاسم التريكي",
          accountNumber: "221380",
          netSalary: 923.925,
        },
      ],
    };
  },
  methods: {
    formatValues(value) {
      if (!value) {
        return value;
      }
      return value.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-14";
</style>
